// react and mui stuff
import { useContext, useEffect, useState } from "react"
import { UserContext } from "../../utils/contexts"
import { ToastContext } from "../../components/toast"

import {
  extendTheme as materialExtendTheme,
  CssVarsProvider as MaterialCssVarsProvider,
  THEME_ID as MATERIAL_THEME_ID,
} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import { CssVarsProvider as JoyCssVarsProvider, useColorScheme } from '@mui/joy/styles';

import TabList from "@mui/joy/TabList"
import Tabs from "@mui/joy/Tabs"
import Tab from "@mui/joy/Tab"
import TabPanel from "@mui/joy/TabPanel"


// custom components
import { MetaProps } from "../../components/metaprops";
import ChannelXpReport from "./channelxp";
import RankErrorsReport from "./rankerrors";
import HousesReport from "./houses";

// data and stuff
import { ChannelXPReport, HouseReport, RankReport } from "../../types/reports"

function SillyMaterialXThing({ children }: { children: any}){
  const materialTheme = materialExtendTheme();
  return (
    <MaterialCssVarsProvider theme={{ [MATERIAL_THEME_ID]: materialTheme }}>
      <JoyCssVarsProvider>
        <CssBaseline enableColorScheme />
          {children}
        </JoyCssVarsProvider>
    </MaterialCssVarsProvider>
  )
}

export default function ReportPage() {
  const [xpReport, setXpReport] = useState<ChannelXPReport>()
  const [rankReport, setRankReport] = useState<RankReport[]>()
  const [houseReport, setHouseReport] = useState<HouseReport[]>()

  const { setToast } = useContext(ToastContext)
  const { user, setUser } = useContext(UserContext)
  const { setMode } = useColorScheme()
  // data fetching effect
  useEffect(() => {
    setMode("light");
  }, [setMode])

  if (!user) return <></>  
  
  return (
    <SillyMaterialXThing>
      <MetaProps meta={{
        splash: "april fools",
        title: "Reports",
        url: "reports",
        description: "Get reports on server activity and house engagement"
      }}
      />
      <div className="contentRoot">
        <h1 className="pageTitle">Reports</h1>
        <Tabs defaultValue={"channelxp"}>
          <TabList>
            <Tab value={"channelxp"}>Channel XP</Tab>
            <Tab value={"rankerrors"}>Rank Errors</Tab>
            <Tab value={"houses"}>Houses</Tab>
          </TabList>
          <TabPanel value={"channelxp"}>
              <ChannelXpReport setReport={setXpReport} report={xpReport} setToast={setToast} setUser={setUser} user={user}/>
          </TabPanel>
          <TabPanel value={"rankerrors"}>
            <RankErrorsReport report={rankReport} setReport={setRankReport} setToast={setToast} setUser={setUser} user={user}/>
          </TabPanel>
          <TabPanel value={"houses"}>
            <HousesReport report={houseReport} setReport={setHouseReport} setToast={setToast} setUser={setUser} user={user}/>
          </TabPanel>
        </Tabs>
        <br/>
      </div>
    </SillyMaterialXThing>
  )
}